import type { ReactNode } from 'react';

export interface ProviderUI {
  name: string;
  label: string;
  icon: ReactNode;
}

/**
 * cosmic 디자인의 PROVIDERS — Login 페이지의 SSO 버튼 라벨/아이콘.
 * microsoft / ldap 만 우선 wired, 나머지 (google/okta/saml) 는 향후 활성화 시
 * 백엔드 추가만으로 자동 노출되도록 미리 등록.
 */
export const PROVIDERS: Record<string, ProviderUI> = {
  microsoft: {
    name: 'Microsoft',
    label: 'Microsoft 계정으로 계속',
    icon: (
      <svg className="icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <title>Microsoft</title>
        <rect x="2" y="2" width="9" height="9" fill="#F25022" />
        <rect x="13" y="2" width="9" height="9" fill="#7FBA00" />
        <rect x="2" y="13" width="9" height="9" fill="#00A4EF" />
        <rect x="13" y="13" width="9" height="9" fill="#FFB900" />
      </svg>
    ),
  },
  google: {
    name: 'Google',
    label: 'Google 계정으로 계속',
    icon: (
      <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
        <title>Google</title>
        <path
          fill="#4285F4"
          d="M22.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.32z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.16v2.84C3.97 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.1A6.97 6.97 0 0 1 5.46 12c0-.73.13-1.44.36-2.1V7.07H2.16A11 11 0 0 0 1 12c0 1.78.43 3.46 1.16 4.93l3.68-2.84z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.97 3.47 2.16 7.07l3.68 2.84C6.71 7.31 9.14 5.38 12 5.38z"
        />
      </svg>
    ),
  },
  okta: {
    name: 'Okta',
    label: 'Okta SSO로 계속',
    icon: (
      <svg className="icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <title>Okta</title>
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" fill="none" />
        <circle cx="12" cy="12" r="3" fill="currentColor" />
      </svg>
    ),
  },
  saml: {
    name: 'SAML SSO',
    label: '회사 계정 (SAML SSO)로 계속',
    icon: (
      <svg
        className="icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <title>SAML SSO</title>
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
  },
  ldap: {
    name: 'LDAP',
    label: 'LDAP 디렉토리로 로그인',
    icon: (
      <svg
        className="icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <title>LDAP</title>
        <ellipse cx="12" cy="5" rx="8" ry="2.5" />
        <path d="M4 5v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5V5" />
        <path d="M4 11v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-6" />
      </svg>
    ),
  },
  isign: {
    name: 'ISign+',
    label: 'ISign+ 로 로그인',
    icon: (
      <svg
        className="icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <title>Pentasecurity ISign+</title>
        <path d="M12 2L4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
};
